import * as Yup from "yup";

const AdminContactSupportSchema = () =>
  Yup.object().shape({
    reference_transaction_id: Yup.string()
      .label("Reference Transaction-ID")
      .nullable(),
    reference_username: Yup.string().label("Reference Username").nullable(),
    contact_support_reason_id: Yup.string().label("Reason").required(),
    assigned_to_id: Yup.string().label("Assigned To").required(),
    participant_id_1: Yup.string().label("Participant 1").required(),
    participant_id_2: Yup.string().label("Participant 2").nullable(),
    opening_message: Yup.string().label("Opening Message").required(),
  });

export default AdminContactSupportSchema;
